// Initialize the class when the DOM is loaded and if the product-lifecycle element exists
import MatchHeight from 'vanilla-js-match-height';

document.addEventListener('DOMContentLoaded', () => {
  if (document.querySelector('[data-mh]')) {
    const mh = new MatchContentHeight();
    mh.init();
  }
});

class MatchContentHeight {
  constructor() {
    this.instances = [];
  }

  init() {
    // Find all elements with data-mh attribute
    const elements = document.querySelectorAll('[data-mh]');

    // Group elements by their data-mh attribute value
    const groupedElements = {};

    elements.forEach((element) => {
      const attributeValue = element.getAttribute('data-mh');
      if (!groupedElements[attributeValue]) {
        groupedElements[attributeValue] = [];
      }
      groupedElements[attributeValue].push(element);
    });

    // Apply MatchHeight to each group
    Object.keys(groupedElements).forEach((group) => {
      this.instances.push(new MatchHeight(`[data-mh="${group}"]`));
    });

    // Re-measure once images and lazy-loaded CSS chunks have applied
    window.addEventListener('load', () => this.update());
    document.addEventListener('css-chunk:loaded', () => this.update());
  }

  update() {
    this.instances.forEach((instance) => instance.reset());
  }
}
